import { Store } from 'redux'
import { sessionPersistService } from '../service/sessionPersist.service'
import { isTokenValid } from '../../../../utilities/auth.util'
import { navigateTo } from '../../../../utilities/navigation.util'
import { AppRouterConstants } from '../../../../components/appRouter/AppRouter.constants'
import Logger from '../../../../services/logger.service'
import { ISessionUser } from '../../resume/store/sessionResume.types'
import { initialSessionResumeState } from '../../resume/store/sessionResume.reducers'
import { setMetadata, setShowModal } from '../store/sessionPersist.actions'

export const preloadSessionPersistData = async (store: Store): Promise<void> => {
  if (!isSessionPersistenceEnabled()) return
  try {
    const metadata = await sessionPersistService.loadMetadata()
    if (metadata) {
      store.dispatch(setMetadata(metadata))
      store.dispatch(setShowModal(true))
      Logger.info('[SessionPersist] Pre-render: metadata loaded, modal ready on first frame')
    }
  } catch (error) {
    Logger.error(`[SessionPersist] Pre-render check failed: ${error}`)
  }
}

export const isSessionPersistenceEnabled = (): boolean => {
  return process.env.REACT_APP_TOGGLE_PERSIST_SESSION_FEATURE !== 'false'
}

export const isSessionResumeInitialState = (sessionUser: ISessionUser | null): boolean => {
  if (!sessionUser) return false
  const currentSessionResumeString = JSON.stringify(sessionUser)
  const initialSessionResumeString = JSON.stringify(initialSessionResumeState)
  return currentSessionResumeString === initialSessionResumeString
}

export const handleSessionPersistenceEnabled = async () => {
  try {
    const metadata = await sessionPersistService.loadMetadata()

    if (!metadata || !metadata.user) {
      Logger.info('[SessionPersist] No metadata found, skipping JWT check')
      return true
    }

    const authState: any = metadata.user.authState
    const tokenString = authState?.idToken?.idToken || authState?.accessToken?.accessToken

    if (!tokenString) {
      try {
        Logger.info('[SessionPersist] No token in metadata, clearing metadata & redirecting user to login')
        await sessionPersistService.clearMetadata()
        navigateTo(AppRouterConstants.LOGIN_ROUTE)
      } catch (error) {
        Logger.error(`Error navigating to login: ${error}`)
        window.location.href = AppRouterConstants.LOGIN_ROUTE
      }
      return false
    }

    const isValid = isTokenValid(tokenString)

    if (!isValid) {
      try {
        Logger.info('[SessionPersist] Token invalid or expiring soon, clearing metadata & redirecting user to login')
        await sessionPersistService.clearMetadata()
        navigateTo(AppRouterConstants.LOGIN_ROUTE)
      } catch (error) {
        Logger.error(`Error navigating to login: ${error}`)
        window.location.href = AppRouterConstants.LOGIN_ROUTE
      }
      return false
    }
    return true
  } catch (error) {
    Logger.error(`Error handleSessionPersistenceEnabled: ${error}`)
    return true
  }
}
